// DOMParser doesn't trigger resource loads (e.g. <img src=...>), unlike innerHTML
export function stripHtml(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}
